<template>
  <div class="box-content">
    <img class="s" :src="imageSUrl">
    <img class="m" :src="imageMUrl">
  </div>
</template>

<script>
export default {
  props: {
    imageSUrl: String,
    imageMUrl: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.box-content {
  border-bottom: 6px solid rgb(173, 173, 173);

  img {
    margin-bottom: 22px;
    width: 100%;
    height: auto;
    background-color: $light;
  }

  .s {
    display: block;
  }

  .m {
    display: none;
  }

  @media only screen and (min-width: $break-m) {
    .s {
      display: none;
    }

    .m {
      display: block;
    }
  }
}
</style>
